import { API2_HOST} from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch,
  baseGet
} from 'services/base-services/baseService';
import { getMaxtrixUsers } from 'services/userServices';

const baseURL = `${API2_HOST}/sm-training-records`;
import axios from "services/api";;
import { objectToQueryString } from 'helpers/utils';
axios.defaults.withCredentials = true;


const search = async request => {
  return await baseSearch(baseURL, request);
};

const getNotCompletes = async request => {
  return await baseSearch(baseURL + '/get-incomplete-records', request);
};

const getNotCompleteUsers = async request => {
  return await baseSearch(baseURL + '/get-incomplete-users', request);
};

const searchUsers = async request => {
  const allUsers = await getMaxtrixUsers();
  if (!request.ids) {
    return { items: allUsers, total: allUsers.length };
  }

  const userByUserId = new Map(allUsers.map(u => [u.userId?.toString(), u]));
  const items = request.ids.map(x => {
    const traineeId = x.trainee?.toString();
    const matchedUser = userByUserId.get(traineeId);
    if (matchedUser) return matchedUser;

    console.warn(`No matrix user found for trainee id ${traineeId}`);
    return { userId: x.trainee, name: `Unknown user (ID: ${x.trainee})`, login: '' };
  });

  return { items, total: items.length };
};

const post = async request => {
  return await basePost(baseURL, request);
};

const get = async id => {
  return await baseGet(baseURL, id);
};

const getByParam = async param => {
  const paramStr = `by-param?${objectToQueryString(param)}`;
  return await baseGet(baseURL, paramStr);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

export {
  search,
  post,
  patch,
  get,
  getByParam,
  searchUsers,
  getNotCompletes,
  getNotCompleteUsers
};
